module.exports = __webpack_public_path__ + "img/scatter_freespin.fc5920d8.png";